export default {
  sidebarCollapsed: false,
  pageTitle: '',
  searchTerm: '',
  pageSearchRoute: '',
  pageBreadcrumbs: [],
  pageHeaderEnabled: true,
  fullscreen: true,
  icons: {
    social: {
      facebook: { icon: 'fa-facebook', color: '#4767aa' },
      instagram: { icon: 'fa-instagram', color: '#ed1f65' },
      mail: { icon: 'fa-envelope-o', color: '#f39522' },
      whatsapp: { icon: 'fa-whatsapp', color: '#0fa251' },
      whatsappweb: { icon: 'fa-whatsapp', color: '#0fa251' },
      wechat: { icon: 'fa-wechat', color: '#7bb32e' },
      twitter: { icon: 'fa-twitter', color: '#1da1f2' },
      mobile: { icon: 'fa-mobile', color: '#2993cf' },
      sms: { icon: 'fa-mobile', color: '#2993cf' },
      webhook: { icon: 'fa-globe', color: '#cf2941' },
      cellfind: { icon: 'fa-mobile', color: '#2993cf' },
      ussd: { icon: 'fa-industry', color: '#ffffff' },
    },
    navigation: {
      campaigns: '/static/assets/icons/',
      channels: '',
      filebox: '',
      interactions: '',
      profiles: '',
      wallet: '',
      company: '',
    },
    plain: {
      pink: '/static/assets/icons/plain/pink.png',
      purple: '/static/assets/icons/plain/purple.png',
      teal: '/static/assets/icons/plain/teal.png',
      yellow: '/static/assets/icons/plain/yellow.png',
    },
    file: {
      log: '/static/assets/icons/plain/pink.png',
      xlsx: '/static/assets/icons/plain/purple.png',
      xls: '/static/assets/icons/plain/teal.png',
      pdf: '/static/assets/icons/plain/yellow.png',
      doc: '/static/assets/icons/plain/pink.png',
      csv: '/static/assets/icons/plain/teal.png',
    },
    campaign: {
      edit: '/static/assets/icons/canpaign/edit.png',
      download: '/static/assets/icons/campaign/download.png',
      live: '/static/assets/icons/campaign/live.png',
      winner: '/static/assets/icons/campaign/winner.png',
      trash: '/static/assets/icons/campaign/trash.png',
      stats: '/static/assets/icons/campaign/stats.png',
    },
  },
  channelTypes: {
    0: 'sms',
    1: 'mail',
    2: 'twitter',
    3: 'facebook',
    4: 'gplus',
    6: 'wechat',
    7: 'webhook',
    8: 'ussd',
    9: 'whatsapp',
    10: 'instagram',
    11: 'cellfind',
    12: 'telegram',
    13: 'whatsappweb',
  },
};



// WEBPACK FOOTER //
// ./src/store/app/state.js